import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core'
import { MatDrawer, MatPaginator, MatSnackBar, MatTableDataSource,Sort } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { CourrierService, DialogService,
 DroitsService, StateService,
 UtilitaryService ,
 TiersService,
 ListeService
 } from '../../../../../services'
import { Subject } from 'rxjs/internal/Subject'
import { debounceTime, first } from 'rxjs/operators'
 

declare var $: any

const KEY = 'courrier-dialog'

@Component({
	selector: 'atyl-courrier-dialog',
	templateUrl: 'courrier-dialog.component.html',
	styleUrls: ['./courrier-dialog.component.scss']
})
@Stringable({
	path: 'views/partials/layout/dialogs/courrier-dialog',
	key: KEY,
})
export class CourrierDialog extends BaseDialogComponent implements OnInit {

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
	@ViewChild('drawer', { static: true }) drawer: MatDrawer
 		
	@StringableValues(KEY) strings: any
	droits: any = [];
	signatureButon:any;
	config: any = {
		height: '64vh',
		toolbar: [
			['slider', ['leftpanel']],
			['courrier', ['ccourrierPrevious','courrierNext']],
			['style', ['bold', 'italic', 'underline']],
			['para', ['ul', 'ol', 'paragraph', 'height']],
			['insert', ['table','pagebreak','signature']],
			['download', ['pdf']]
		],
		buttons: {
			'ccourrierPrevious':this.customButtonHtmlPrevious.bind(this),
            'courrierNext':this.customButtonHtmlNext.bind(this),
            'pagebreak': this.customButtonPageBreak.bind(this),
			'signature': this.customButtonSignature.bind(this),
            'leftpanel': this.customButtonLeftPanel.bind(this)
          }
	};

	objectKeys = Object.keys;
	courriers: any[]
	formats: any[]
	typeCourrier: any[]
	autreCourriers: any[]
	result: any = {
		selectedCourrier: {},
		selectedCourrierDossier: [],
		selectedDestinataire: [],
		selectIndex: 0,
		selectedFormat: "",
		
	};
	courrierType: any[] = [];
	courrierAutre: any[] = [];

	destinataire: any
	cachedDemande: any

	isEditable: boolean = true;

	dataSource = new MatTableDataSource();

	columns: any[] = [];
	displayedColumns = [];

	length: number = 0;
	pageSize: number = 5;
	currentPage: number = 0;
	page: number = 0;

	expanded: any[] = [];

	totalLength: number = 0;
	loading: boolean = false;
	expandedElement: any

	filters: any
	sort: any

	loadingCour: boolean = false;
	dossierInit: any

	_optionsCourrier: any
	_optionsCourrierDossiers: any[]=[];
	
	demandeCourrierId: number
	
	intervention:any;
	instruction:any;
	
	panierLines:any=[];
	
	tierType:any;
	tierTypeOptions: any = [];
	
	private debounceTiers: Subject<string> = new Subject();
	autocompTiersList: any
	
	nativeMultiple:boolean=false;
	selectedRelation: any = {};
	isClickBtn:boolean=false;
	isSendToGED: boolean = false;
	
	demande_type:any;
	consultation:any;
	
	courrierID:number=0;
	isSign:boolean=false;
	signataires:any=[];
	
	
	constructor(
		public dialogRef: MatDialogRef<CourrierDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private courrierService: CourrierService,
		private utilities: UtilitaryService,
		public stateService: StateService,
		changeDetectorRef: ChangeDetectorRef,
		public droitsService: DroitsService,
		dialogService: DialogService,
		private _snackBar: MatSnackBar,
		private tiersService: TiersService,
		private listeService: ListeService
	) {
		super(dialogRef, dialogService, changeDetectorRef)
		
	}

	ngOnInit() {
		
		this.getTiersTypeOptions();
		
		 this.drawer.openedChange.subscribe((o: boolean) => { 
		     console.log("_drawerToggle IsOpen: ",o)
			 if (!o) {
				console.log("_drawerToggle refresh",this._optionsCourrierDossiers);
				   this.initCourrier();
				} 
		  });
   	 
		
		this.debounceTiers.pipe(debounceTime(1000)).subscribe((search) => {
			if (search.length > 0 
					&& this.tierType!=undefined) {
				let _opts={
					search:	search
				};
				this.tiersService.search(this.tierType.code,_opts).subscribe((result: JSONRpcResponse) => {
					
					this.autocompTiersList = result.result.datas;
					
					this.changeDetectorRef.detectChanges()
				})
			}
		})
		
		this.demandeCourrierId = this.data.demandeId ? this.data.demandeId : 0
		
		
		if (this.data != undefined && this.data.panierLines != undefined  && this.data.panierLines) {
            this.panierLines = this.data.panierLines
        }
		
		if (this.data != undefined && this.data.intervention != undefined  && this.data.intervention) {
            this.intervention = this.data.intervention
        }
        
        if (this.data != undefined && this.data.instruction != undefined  && this.data.instruction) {
            this.instruction = this.data.instruction
        }
        if (this.data != undefined && this.data.demande_type != undefined) {
            this.demande_type = this.data.demande_type;
        }
		
		if (this.data != undefined && this.data.consultation != undefined) {
		     this.consultation = this.data.consultation;
		}
		
		if (this.data != undefined && this.data.isEditable != undefined) {
		           this.isEditable = this.data.isEditable
		  }
			   
        console.log("CourrierDialog ngOnInit",this.data,this.isEditable);
        
		if (this.data && this.data.courrier) {
			if (this.data.dossier) {
				
				if (this.data.courrier !=undefined 
				&& this.data.courrier.courrier !=undefined
				&& this.data.courrier.courrier.ID !=undefined	
				&& this.data.courrier.courrier.signature!=undefined
				&& this.data.courrier.courrier.signature>0
				) {
					if (this.data.courrier.signataires!=undefined) {
					  this.courrierID=this.data.courrier.courrier.ID;
					  this.signataires=this.data.courrier.signataires;
					  this.isSign=true;
					}
				}
				this._optionsCourrier = {
					/*dossier: this.data.dossier.ID,*/
					courrier: this.data.courrier.courrier.key,
					alldossier: true,
					intervention: this.intervention
				}
				if (this.data.dossier.tiers!=undefined) {
					this.destinataire=this.data.dossier.tiers;
					this._optionsCourrier.destination=this.destinataire.dossierID;
				}
				if (this.data.courrier.destination!=undefined &&
				this.data.courrier.destination
				 ) {
					
					this.destinataire=this.data.courrier.destination;
					this._optionsCourrier.destination=this.data.courrier.destinationD;
					
				}
				
				
					this.filters = {
	                dossier : {
	                    value : (this.data.dossier.dossierID!=undefined) 
	                    		?  this.data.dossier.dossierID
	                    		 :this.data.dossier.ID
	                }
	           	}
            
				
				this._optionsCourrier.dossier=(this.data.dossier.dossierID!=undefined) ? this.data.dossier.dossierID:this.data.dossier.ID;
			
        
                if (this.instruction!=undefined && this.instruction) {
                    console.log("document instruction",this.instruction);
                    this._optionsCourrier.instruction=this.instruction.ID;
                  }  
    
				
				
			}
			
			if (this.panierLines.length>0 && this._optionsCourrier) {
				this.nativeMultiple=true;
				console.log("ngOnIndossier0it",this.panierLines[0])
				this.destinataire=this.panierLines[0].dossier;
				this._optionsCourrier.destination=this.destinataire.dossierID;
				
				this.filters = {
                    dossier : {
                        value : this.destinataire.dossierID
                    }
            	}
				
				
				for(let i=0;i<this.panierLines.length;i++) {
                    console.log("TEST_PANIER_LINES",this.panierLines[i]);
					let ops:any={
						courrier: this.data.courrier.courrier.key,
						alldossier: true,
						intervention: this.intervention,
						dossier: null,
						destination:this.panierLines[i].dossier.dossierID,
                        instruction: null,
						demande_type: this.demande_type,
						signataire:(this.data.courrier!=undefined && this.data.courrier.signataire!=undefined && this.data.courrier.signataire.ID!=undefined  )
						? this.data.courrier.signataire.ID: null,
					};
					
					if (this.data.courrier !=undefined 
					&& this.data.courrier.courrier !=undefined
					&& this.data.courrier.courrier.ID !=undefined	
					&& this.data.courrier.courrier.signature!=undefined
					&& this.data.courrier.courrier.signature>0
					) {
						if (this.data.courrier.signataires!=undefined) {
						  this.courrierID=this.data.courrier.courrier.ID;
						  this.signataires=this.data.courrier.signataires;
						  this.isSign=true;
						}
					}
				    ops.dossier=(this.panierLines[i].dossier.dossierID!=undefined) ? this.panierLines[i].dossier.dossierID: this.panierLines[i].dossier.ID;
                    ops.instruction = (this.panierLines[i] && this.panierLines[i].instruction ? this.panierLines[i].instruction.ID : null)
					if (this.panierLines[i] && this.panierLines[i].visite!=undefined)
						ops.visite=this.panierLines[i].visite
					if (this.consultation!=undefined)
						ops.consultation=this.consultation
				    console.log("ngOnInit",ops,this.panierLines[i]),
					this._optionsCourrierDossiers.push(ops);
					
					this.result.selectedDestinataire.push(this.panierLines[i].dossier);
				}
			}
			
			
			if (!this.nativeMultiple) {
				let ops:any={
						courrier: this.data.courrier.courrier.key,
						alldossier: true,
						intervention: this.intervention,
						dossier: this.data.dossier.tiers.dossierID,
						destination: this.data.dossier.tiers.dossierID,
                        instruction: (this.instruction!=undefined && this.instruction ) ? this.instruction.ID: null,
						demande_type: this.demande_type,
						signataire:(this.data.courrier!=undefined && this.data.courrier.signataire!=undefined && this.data.courrier.signataire.ID!=undefined  )
						 ? this.data.courrier.signataire.ID: null,
					};
				
					if (this.data.courrier !=undefined 
						&& this.data.courrier.courrier !=undefined
						&& this.data.courrier.courrier.ID !=undefined	
						&& this.data.courrier.courrier.signature!=undefined
						&& this.data.courrier.courrier.signature>0
					  ) {
					  	
					 	 
					  if (this.data.courrier.signataires!=undefined) {
						  this.courrierID=this.data.courrier.courrier.ID;
						  this.signataires=this.data.courrier.signataires;
						  this.isSign=true;
					  }
					}
					if (this.selectedRelation[ops.destination+""]==undefined)
						this.selectedRelation[ops.destination+""]=false;
					this.selectedRelation[ops.destination+""]=true;
				
					this._optionsCourrierDossiers.push(ops);
					console.log("ngOnInit nort Mulit",ops,this.data.courrier);
				  this.result.selectedDestinataire.push(this.data.dossier);
				
			}
			
			
			
			
		}
		
		
		
		if (this.data.courrier) {
			this.initCourrier()
		} else {
			this.result.selectedCourrier = this.data.courrier.courrier
		}
	}
	
	getTiersTypeOptions() {
		
			this.tiersService.getTiersType().subscribe((res: JSONRpcResponse) => {
				if (res.result) {
					this.tierTypeOptions = res.result
					if (this.tierTypeOptions.length>0)
						this.tierType=this.tierTypeOptions[0];
					
					this.changeDetectorRef.detectChanges()
				}
			})
		
	}

	initCourrier() {
        //Multi courrier panier
		this.loadingCour=true;
		if (this._optionsCourrierDossiers.length>0){
            this.courrierService.htmlMulti(this.demandeCourrierId, this._optionsCourrierDossiers).subscribe((response: JSONRpcResponse) => {
                this.loadingCour=false;
                if (response && response.result && response.result[0]) {
                    this.result.selectedCourrier = response.result[0];
					this.result.selectedCourrierDossier = response.result;
					console.log('initCourrier',this.result.selectedCourrierDossier, this.result);
					this.getDataPage();
				}
			})
			/*
			if (this.courrierID>0) {
				let _optsS:any={
					
				}
				this.courrierService.getSignataireList(this.courrierID, _optsS).subscribe((response: JSONRpcResponse) => {
				    console.log("CourrierDialog getSignataireList",response);
					if (response.result) {
						this.signataires=response.result;
						
					    this.config.buttons["signature"]=(function(context) {
							return this.customButtonSignature(context);
						});
						this.changeDetectorRef.detectChanges();
												
					}
				})
				
			}
			*/
			
            /*
		   for(let i=0;i<this._optionsCourrierDossiers.length;i++) {
			this.courrierService.html(this.demandeCourrierId, this._optionsCourrierDossiers[i]).subscribe((response: JSONRpcResponse) => {
				if (response && response.result) {
					if(i==0){
                        this.result.selectedCourrier = response.result;
                    }
					this.result.selectedCourrierDossier.push(response.result)
					console.log('initCourrier',this._optionsCourrierDossiers[i], this.result);
				}
			})
		   }*/
        }
        else{
            this.courrierService.html(this.demandeCourrierId, this._optionsCourrier).subscribe((response: JSONRpcResponse) => {
                if (response && response.result) {
                    this.result.selectedCourrier = response.result
                }
                this.loadingCour=false;
                this.getDataPage();
            })
        }
		
	}

	saveCourrier(event: MouseEvent) {
		if (!this.isClickBtn) {
			this._optionsCourrier.GED = this.isSendToGED;
			if (this._optionsCourrierDossiers.length==0) {
				this._optionsCourrier.html = this.result.selectedCourrier.html
				console.log("saveCourrier one",this._optionsCourrier);
				this.isClickBtn=true;
				this.subscriptions.push(
					this.courrierService.get(this.demandeCourrierId, this._optionsCourrier).subscribe((response: JSONRpcResponse) => {
						this.dialogRef.close(response.result)
						this.isClickBtn=false;
						this._snackBar.open('le courrier est enregistré', "ok", {
							duration: 2000
						})
					})
				)
			} else {
				this.isClickBtn=true;
				let _opt:any[]=[];
				//Actualiser la page actuelle
				this.result.selectedCourrierDossier[this.result.selectIndex]=this.result.selectedCourrier;
				//this._optionsCourrierDossiers[this.result.selectIndex].html = this.result.selectedCourrier.html
				for(let i=0;i<this._optionsCourrierDossiers.length;i++) {
					this._optionsCourrierDossiers[i].ID=this.demandeCourrierId;
					this._optionsCourrierDossiers[i].html = this.result.selectedCourrierDossier[i].html;
					this._optionsCourrierDossiers[i].GED = this.isSendToGED;
					if (this.result.selectedCourrierDossier[i].signataire!=undefined)
						this._optionsCourrierDossiers[i].signataire=this.result.selectedCourrierDossier[i].signataire;
					//this._optionsCourrierDossiers[i].consultation = this.consultation;
				}
				console.log("saveCourrier multiple",this._optionsCourrierDossiers);
				this.subscriptions.push(
					this.courrierService.gets(this._optionsCourrierDossiers).subscribe((response: JSONRpcResponse) => {
						this.dialogRef.close(response.result)
						this.isClickBtn=false;
						this._snackBar.open('le(s) courrier est enregistré(s)', "ok", {
							duration: 2000
						})
					})
				)
					
				
				
				
			}
		}
	}
	
	customButtonLeftPanel(context) {
      //  console.log($.summernote);
        const ui = $.summernote.ui;
        const button = ui.button({
        contents: ' <img id="expandDrawer" class="reverse" src="./assets/media/icons/svg/Navigation/Angle-double-left.svg" />',
        tooltip: 'Plus d\options',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
            this._drawerToggle();
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
    }
	
	customButtonHtmlNext(context) {
		const ui = $.summernote.ui;
        const button = ui.button({
        contents: '<i class="la la-angle-right"></i>',
        tooltip: 'Courrier suivant',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
	        console.log("customButtonHtmlNext",this.result.selectIndex,this.result.selectedCourrierDossier.length,
            this.result.selectedDestinataire,this.result.selectedCourrierDossier)
            if (this.result.selectIndex<this.result.selectedCourrierDossier.length
                && this.result.selectedDestinataire[this.result.selectIndex+1]
                && this.result.selectedCourrierDossier[this.result.selectIndex+1]) {

				this.result.selectedCourrierDossier[this.result.selectIndex]=this.result.selectedCourrier;
			
             	this.result.selectIndex++;
             	this.destinataire=this.result.selectedDestinataire[this.result.selectIndex];
             	this.result.selectedCourrier=this.result.selectedCourrierDossier[this.result.selectIndex];
                console.log("customButtonHtmlNext after",this.result.selectIndex,this.result.selectedCourrierDossier);
            
             }
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
		
    }
    
    customButtonHtmlPrevious(context) {
		const ui = $.summernote.ui;
        const button = ui.button({
        contents: '<i class="la la-angle-left"></i>',
        tooltip: 'Courrier précedent',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
	        console.log("customButtonHtmlPrevouis",this.result.selectIndex,this.result.selectedCourrierDossier.length)
            if (this.result.selectIndex>0) {
				this.result.selectedCourrierDossier[this.result.selectIndex]=this.result.selectedCourrier;
	
				
	
             	this.result.selectIndex--;
             	
             	this.destinataire=this.result.selectedDestinataire[this.result.selectIndex];
             	this.result.selectedCourrier=this.result.selectedCourrierDossier[this.result.selectIndex];
                console.log("customButtonHtmlNext after",this.result.selectIndex,
                this.result.selectedCourrierDossier,this.result.selectedCourrierDossier,
                this.destinataire)
            
             }
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
		
    }
	
	signElement(singID:any) {
		this.result.selectedCourrier.signataire=singID;
		console.log("CourrierDialog signElement",this.result.selectedCourrier);
	}
	
    customButtonSignature(context) {
		
		console.log("CourrierDialog customButtonSignature",context,this,this.isSign,this.signataires)
		if (this.isSign && this.courrierID>0 && this.signataires.length>0 ) {
		
						
			const ui = $.summernote.ui;	
			var li:string[]=[];
			var lis:string[]=[];
			
			var profs:any={
				"AUTRES": {
					pro:"Autres",
					children:[]
				}
			};
			
			for(let i=0;i<this.signataires.length;i++) {
				let s:any=this.signataires[i];
				li.push('<li class="dropdown-item" data-id="'+s.ID+'">'+ s.nom+" "+s.prenom+"</li>");
				lis.push(s.nom + " " + s.prenom);
				let added:boolean=false;
				if (s.professions!=undefined && s.professions.length==1) {
					let pros:any[]=s.professions;
					for(let j=0;j<pros.length;j++) {
						if (profs[pros[j].key]==undefined) {
							profs[pros[j].key]={
								pro:pros[j].libelle,
								children:[]
							};
						}
						if (!added) {
							profs[pros[j].key].children.push(s);	
							added=true;
						}						
					}
				} 
				else	
					profs["AUTRES"].children.push(s);				
			}
			//let list:string=li.join("");
			var lig:string[]=[];
			Object.keys(profs).forEach((proKey:string) => {
			    let pf:any=profs[proKey];
				
				if (pf.children!=undefined && pf.children.length>0) {
					lig.push('<div class="card">');
					lig.push('<div class="card-header">' + pf.pro + '</div>');
					lig.push('<div class="card-body">');
					for(let i=0;i<pf.children.length;i++) {
						let s:any=pf.children[i];
						lig.push('<li class="list-group-item dropdown-item" data-id="'+s.ID+'">'+ s.nom+" "+s.prenom+"</li>");
					}	
					lig.push('</div>');
					lig.push('</div>');
				}
				
			})
			let list:string=lig.join("");
			
			
			// var list:any =;
			let signService:any=this.courrierService;			
			let cID:number=this.courrierID;	
			let selC:any=this;
			
			var dropdown = ui.dropdown({
			  //className: 'dropdown-variable dropdrownSignataire',
			  className: 'drop-default summernote-list dropdrownSignataire',
			  contents: list,
			   container: false,
			//	tooltip: 'Signer',
				callback: function ($dropdown) {
					console.log("CourrierDialog customButtonSignature dropdown",$dropdown,this);
				    $dropdown.find('li').each(function () {
					      $(this).click(function() {
							var idSign= $(this).attr("data-id");
							signService.getSignature(idSign).subscribe((response: JSONRpcResponse) => {
								if (response.result && response.result.html!=undefined) {
										let html=response.result.html;
										context.invoke('editor.restoreRange');
										context.invoke('editor.focus');
										context.invoke('editor.pasteHTML', html);
										console.log("CourrierDialog customButtonSignature dropdown",selC)
										if (selC.result.selectedCourrier!=undefined) {
											selC.signElement(idSign);
										}
									
								}
							})
							
					      });
				    });
				}
			});
			
				
							
			var button:any = ui.buttonGroup(
				     {
					tooltip: 'Signer',
					children:	[
			         ui.button({
			           // className: 'dropdown-toggle',
			            contents: '<i class="la la-signature" title="Signer" aria-label="Signer"></i><i  title="Signer" class="la la-caret-down"></i>',
			            tooltip: "Signer",
						container: '.note-editor',
						className: 'note-btn',
			            data: {
			              toggle: 'dropdown'
			            }
			          }),
					   dropdown
					 
			]});
			/*var button:any =ui.button({
			  className: 'dropdown-toggle',
			  contents: '<i class="la la-file-signature" title="Signer" aria-label="Signer"></i><i  title="Signer" class="la la-caret-down"></i>',
			  tooltip: "Signer",
			container: false,
			  data: {
			    toggle: 'dropdown'
			  },
			   children:	[
					dropdown
				]
			});*/
			
			
			return button.render()	
						
												
						
					
			
			
			
		}
		return null;
			
	}
	
	customButtonPageBreak(context) {
       // console.log($.summernote);
        const ui = $.summernote.ui;
        const button = ui.button({
        contents: '<i class="la la-copy"></i>',
        tooltip: 'Insert nouvelle page',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
            
             let html='<div style="page-break-after:always; clear:both"><i class="la la-copy" title="Nouvelle page"></i></div>';
             context.invoke('editor.restoreRange');
             context.invoke('editor.focus');
             context.invoke('editor.pasteHTML', html);
             
             console.log("to insrt html",html);
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
    }
    
    triggerAutocompTiersList(search: any) {
		this.debounceTiers.next(search)
	}
	
	displayAutoTiersList(key?: any): string | undefined {
		
		let selected
		if (this.autocompTiersList) {
			this.autocompTiersList.forEach((select) => {
				if (select.ID === key.ID) {
					selected = select
					this._optionsCourrier.destination=key.dossierID;
					
					if (this.result.selectedDestinataire.length>0) {
					 	this.result.selectedDestinataire[this.result.selectIndex]=key;
					 	this._optionsCourrierDossiers[this.result.selectIndex].destination=key.dossierID
					}
					this.initCourrier()
					
			    }
			})
		}
		return selected ? selected.NOM+ " " +selected.PRENOM : undefined
	}
	
	getDataPage(page:number=0,init:boolean=false,_nodata:boolean=false) {
        
        let _options={
          page:page,
          filters:this.filters,
          sorts: [this.sort]
          };
      // this.loadingCour=true;   
       this.loading=true;
        this.listeService.get("RELATION",_options,_nodata)
              .subscribe((list: JSONRpcResponse) => {
            this.loading = false;
           // this.loadingCour=false;   
            this.columns=list.result.columns;
            /*this.columns.unshift({
                id: 'radio',
                label:""
            });
            */
		   this.columns.unshift({
                id: 'checkbox',
                label:""
            });
		   
            this.displayedColumns = this.columns.map(x => x.id);
            if (list.result.datas.meta) {
                this.length=list.result.datas.meta.total;
                this.pageSize=list.result.datas.meta.perpage;
                this.currentPage=list.result.datas.meta.page;
              }
      
		    this.dataSource.data=list.result.datas.datas;
		    for(let i=0;i<this.dataSource.data.length;i++) {
				if (this.selectedRelation[this.dataSource.data[i]["id"]+""]==undefined)
				 	this.selectedRelation[this.dataSource.data[i]["id"]+""]=false;
			}
			console.log("Courrier getDataPage",this.dataSource.data,this.selectedRelation)
		    
		    
		    
            console.log('l',this.length);	
            console.log("get:liste",this.currentPage,this.length,this.columns,this.data);
            
            this.changeDetectorRef.detectChanges();
            if(this.paginator){
                this.paginator._intl.itemsPerPageLabel = "Nombre par page:";
                this.paginator._intl.getRangeLabel = (page, pageSize, length) => { 
                    if (length == 0 || pageSize == 0) {
                         return `0 de ${length}`; 
                    } 
                    length = Math.max(length, 0); 
                    const startIndex = page * pageSize; 
                    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize; 
                    return `${startIndex + 1} – ${endIndex} de ${length}`; 
                };
            }
          });
     }
     
     sortData(sort: Sort) {
		console.log(sort);
		this.loading = true;
	}
	/*onRowClicked(row) {
		this.utilities.log('Row clicked: ', row);
        
        this.destinataire=row.informations;
        
        
		this._optionsCourrier.destination=this.destinataire.dossierID;
		
		if (this.result.selectedDestinataire.length>0) {
		 	this.result.selectedDestinataire[this.result.selectIndex]=this.destinataire;
		 	this._optionsCourrierDossiers[this.result.selectIndex].destination=this.destinataire.dossierID
		}
		this.initCourrier()
        
    }*/

    public handlePage(e: any) {
		//this.currentPage = e.pageIndex;
		//this.pageSize = e.pageSize;
	//	this.dataSource.data=[];
		this.totalLength=0;
		let pagination:any={
			currentPage:e.pageIndex,
			pageSize:  e.pageSize
		};
		this.loading = true;
    }

    getTitle(): string {
        let title = this.strings.title;
      
        if (this.data.courrier) {
          title += ' - ' + this.data.courrier.courrier.libelle;
        }
      
        if (this.result.selectedCourrierDossier.length > 1) {
          title += ' (' + (this.result.selectIndex + 1) + '/' + this.result.selectedCourrierDossier.length + ')';
        }
      
        return title;
    }
    
    setDestinataire(event:any, row:any) {
		
		  
        this.destinataire=row.informations;
        let dest:any=row.informations;
        
        console.log('Elent clicked: ',event, row,this.selectedRelation,this.selectedRelation[dest.dossierID]);
        if (this.selectedRelation[dest.dossierID]!=undefined &&
        	this.selectedRelation[dest.dossierID]
        )
	        {
	        let isexist:boolean=false;
	        for(let i:number=0;i<this._optionsCourrierDossiers.length;i++) {
				if (this._optionsCourrierDossiers[i].destination!=undefined
				&& this._optionsCourrierDossiers[i].destination==this.destinataire.dossierID
				)
				isexist=true;
				
			}
	        if (!isexist) {
				let ops:any={
							courrier: this.data.courrier.courrier.key,
							alldossier: true,
							intervention: this.intervention,
							dossier: this.data.dossier.tiers.dossierID,
							destination:dest.dossierID,
	                        instruction: (this.instruction!=undefined && this.instruction ) ? this.instruction.ID: null
				};
				
				this._optionsCourrierDossiers.push(ops);
				console.log("setDestinataire nort Mulit",ops);
				this.result.selectedDestinataire.push(this.data.dossier);
			}
	        
			
		} else {
			 let index:number=-1;
	        for(let i:number=0;i<this._optionsCourrierDossiers.length;i++) {
				if (this._optionsCourrierDossiers[i].destination!=undefined
				&& this._optionsCourrierDossiers[i].destination==dest.dossierID
				)
				index=i;
				
			}
			console.log("remove courrier before",index,this._optionsCourrierDossiers);
			if (index>=0) {
				this._optionsCourrierDossiers.splice(index, 1);
			}
			console.log("remove courrier after",index,this._optionsCourrierDossiers);
		}	
		/*
		this._optionsCourrier.destination=this.destinataire.dossierID;
		
		if (this.result.selectedDestinataire.length>0) {
			 	this.result.selectedDestinataire[this.result.selectIndex]=this.destinataire;
			 	this._optionsCourrierDossiers[this.result.selectIndex].destination=this.destinataire.dossierID
			}
		*/
		//this.initCourrier()
	}
    
    _isCheckDestinataire(row:any) {
		let checked:boolean=false;
		
		for(let i:number=0;i<this._optionsCourrier.length;i++) {
			if (this._optionsCourrier[i].destination!=undefined
			&& this._optionsCourrier[i].destination==row.ID
			)
			checked=true;
		}
		console.log("_isCheckDestinataire",row,checked);
		return checked;
		
    }
    
    
    _drawerToggle() {
		console.log("_drawerToggle",this.drawer,this.drawer.opened);
		
		this.drawer.toggle();
	}
    


	
}

